import React, {useState} from "react";
import {putElementFromIndexedDB} from "../service/UtilityService.js";
import jwt_decode from "jwt-decode";

const AuthContextMiddleware = React.createContext({
    token: '',
    pin: '',
    error: false,
    countError: null,
    isLoggedIn: false,
    isSetFirstPin: false,
    isSetConfirmedPin: false,
    editPin: false,
    reqImage: '',
    reqImageBase64: '',
    backReqImage: '',
    backReqImageBase64: '',
    snapshots: '',
    secondSnapshot: '',
    thirdSnapshot: '',
    imageId: '',
    pendingDocument: {url: '', base64: '', name: '', mimeType: ''},
    switchUser: null,
    telegramUser: null,
    bankRefsToUpdate: {personId: '', accountHolder: '', iban: '', swiftCode: '', currency: '', id: null},
    login: (token) => {
    },
    policyLogin: (token) => {
    },
    logout: () => {
    },
    loginPin: (pin) => {
    },
    loginConfirmedPin: (pin) => {
    },
    loginOffline: (token, pin) => {
    },
    wrongPin: () => {
    },
    wrongOfflinePin: () => {
    },
    undoPin: () => {
    },
    changePin: () => {
    },
    undoChangePin: () => {
    },
    setPin: () => {
    },
    undoSetPin: () => {
    },
    storeReqImage: (reqImage) => {
    },
    storeReqImageBase64: (reqImageBase64) => {
    },
    storeBackReqImage: (backReqImage) => {
    },
    storeBackReqImageBase64: (backReqImageBase64) => {
    },
    storeSnapshots: (snapshots) => {
    },
    addPendingDocument: (pendingUrl, pendingBase64, pendingName, pendingMimeType) => {
    },
    storeBankRefsToUpdate: (personId, accountHolder, iban, swiftCode, currency, id) => {
    },
})

export const AuthContextProvider = (props) => {
    const [token, setToken] = useState(null);
    const [reqImage, setReqImage] = useState(null);
    const [reqImageBase64, setReqImageBase64] = useState(null);
    const [backReqImage, setBackReqImage] = useState(null);
    const [backReqImageBase64, setBackReqImageBase64] = useState(null);
    const [snapshots, setSnapshots] = useState(null);
    const [pendingDocument, setPendingDocument] = useState({url: '', base64: '', name: '', mimeType: ''});
    const [bankRefsToUpdate, setBankRefsToUpdate] = useState({
        personId: '',
        accountHolder: '',
        iban: '',
        swiftCode: '',
        currency: '',
        id: null
    });
    const userIsLoggedIn = !!token;
    const [switchUser, setSwitchUser] = useState(() => {
            if (sessionStorage.getItem('token')) {
                let decoded = jwt_decode(sessionStorage.getItem('token'))
                if (decoded.realm_access.roles.includes('switch-user')) {
                    return true;
                } else {
                    return false;
                }
            } else return null;
        }
    );
    const [telegramUser, setTelegramUser] = useState(() => {
            if (sessionStorage.getItem('token')) {
                let decoded = jwt_decode(sessionStorage.getItem('token'))
                if (decoded.realm_access.roles.includes('telegram-user')) {
                    return true;
                } else {
                    return false;
                }
            } else return null;
        }
    );
    const [pin, setPin] = useState(true);
    const [tmp, setTmp] = useState(true);
    const [error, setError] = useState(false);
    const [isChangePin, setIsChangePin] = useState(false);
    const userHasFirstPin = !!pin;
    const userHasConfirmedPin = !!tmp;
    const userCouldChangePin = !!isChangePin;
    let count = 0;

    const loginHandler = (newToken, newRefreshToken, pin) => {
        let decoded = jwt_decode(newToken);
        setToken(newToken);
        if (!!pin) {
            setPin(pin);
            setTmp(pin);
        }
        putElementFromIndexedDB('token', newToken)
        sessionStorage.setItem('token', newToken);
        sessionStorage.setItem('refresh_token', newRefreshToken);
        sessionStorage.setItem('login', true);
        sessionStorage.setItem('pin', true);
        sessionStorage.setItem('confirmedPin', true);
        if (decoded.realm_access.roles.includes('switch-user')) {
            setSwitchUser(true)
        } else {
            setSwitchUser(false)
        }
        setTelegramUser(!!decoded.realm_access.roles.includes('telegram-user'));
    };

    const policyLoginHandler = (policyToken) => {
        sessionStorage.setItem('policy_token', policyToken);
    };

    const logoutHandler = () => {
        setToken(null)
        sessionStorage.removeItem('login');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('policy_token');
        sessionStorage.removeItem('refresh_token');
        sessionStorage.removeItem('privacy_policy_dialog');
        sessionStorage.removeItem('ocr_result');
        sessionStorage.removeItem('phone');
        sessionStorage.removeItem('phone_lang');
    }

    const pinHandler = (pin) => {
        setError(false)
        setPin(pin);
        sessionStorage.setItem('pin', true);
    }

    const pinConfirmedHandle = (pin) => {
        setTmp(pin)
        sessionStorage.setItem('confirmedPin', true);
        putElementFromIndexedDB('pin', pin)
        //localStorage.setItem('pinIsActive',true)
    }

    const undoPinHandler = () => {
        setPin(false);
        sessionStorage.removeItem('pin');
    }

    const wrongPinHandle = () => {
        setPin(false);
        sessionStorage.removeItem('pin');
        setError(true);
    }

    const loginOfflineHandler = (newToken, pin) => {
        setError(false);
        setPin(pin);
        setTmp(pin);
        setToken(newToken);
        sessionStorage.setItem('token', newToken);
        sessionStorage.setItem('pin', true);
        sessionStorage.setItem('confirmedPin', true);
        sessionStorage.setItem('login', true);
    }

    const wrongOfflinePinHandle = () => {
        setError(true);
        count++;
    }

    const changePinHandler = () => {
        setPin(false);
        setTmp(false);
        sessionStorage.removeItem('pin');
        sessionStorage.removeItem('confirmedPin');
        setIsChangePin(true);
    }

    const undoChangePinHandler = () => {
        if (pin === null) {
            setToken(null)
            sessionStorage.removeItem('login')
            sessionStorage.removeItem('token')
        } else {
            setPin(true);
            setTmp(true);
            sessionStorage.setItem('pin', true);
            sessionStorage.setItem('confirmedPin', true);
            setIsChangePin(false);
        }
    }

    const setPinHandler = () => {
        setPin(false);
        setTmp(false);
        sessionStorage.setItem('pin', false);
        sessionStorage.setItem('confirmedPin', false);
        //setIsChangePin(true);
    }

    const undoSetPinHandler = () => {
        sessionStorage.setItem('pin', true);
        sessionStorage.setItem('confirmedPin', true);
    }

    const handleStoreReqImage = (data) => {
        setReqImage(data)
    }

    const handleStoreReqImageBase64 = (data) => {
        setReqImageBase64(data)
    }

    const handleStoreBackReqImage = (data) => {
        setBackReqImage(data)
    }

    const handleStoreBackReqImageBase64 = (data) => {
        setBackReqImageBase64(data)
    }

    const handleStoreSnapshots = (data) => {
        setSnapshots(data)
    }

    const handlePendingDocument = (url, base64, name, mimetype) => {
        setPendingDocument({url: url, base64: base64, name: name, mimeType: mimetype})
    }

    const handleBankRefsToUpdate = (personId, accountHolder, iban, swiftCode, currency, id) => {
        setBankRefsToUpdate({
            personId: personId,
            accountHolder: accountHolder,
            iban: iban,
            swiftCode: swiftCode,
            currency: currency,
            id: id
        })
    }

    const contextValue = {
        token: token,
        pin: pin,
        error: error,
        countError: count,
        isLoggedIn: userIsLoggedIn,
        isSetFirstPin: userHasFirstPin,
        isSetConfirmedPin: userHasConfirmedPin,
        editPin: userCouldChangePin,
        reqImage: reqImage,
        reqImageBase64: reqImageBase64,
        backReqImage: backReqImage,
        backReqImageBase64: backReqImageBase64,
        snapshots: snapshots,
        pendingDocument: pendingDocument,
        switchUser: switchUser,
        telegramUser: telegramUser,
        bankRefsToUpdate: bankRefsToUpdate,
        login: loginHandler,
        policyLogin: policyLoginHandler,
        logout: logoutHandler,
        loginPin: pinHandler,
        undoPin: undoPinHandler,
        loginConfirmedPin: pinConfirmedHandle,
        loginOffline: loginOfflineHandler,
        wrongPin: wrongPinHandle,
        wrongOfflinePin: wrongOfflinePinHandle,
        changePin: changePinHandler,
        undoChangePin: undoChangePinHandler,
        setPin: setPinHandler,
        undoSetPin: undoSetPinHandler,
        storeReqImage: handleStoreReqImage,
        storeReqImageBase64: handleStoreReqImageBase64,
        storeBackReqImage: handleStoreBackReqImage,
        storeBackReqImageBase64: handleStoreBackReqImageBase64,
        storeSnapshots: handleStoreSnapshots,
        addPendingDocument: handlePendingDocument,
        storeBankRefsToUpdate: handleBankRefsToUpdate,
    }
    return (<AuthContextMiddleware.Provider value={contextValue}>{props.children}</AuthContextMiddleware.Provider>);
};

export default AuthContextMiddleware;
